export type User = {
  email: string;
  roles: string[];
  invitedBy?: string;
  invitedAt?: Date;
  acceptedAt?: Date;
  accepted?: boolean;
};

export type EntityInformation = {
  id: string;
  name: string;
  description: string;
  addressLineOne: string;
  addressLineTwo: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  sectors: string[];
};

export class EklipxResearchUser implements User {
  email: string;
  roles: string[];
  invitedBy?: string | undefined;
  invitedAt?: Date | undefined;
  acceptedAt?: Date | undefined;
  accepted?: boolean | undefined;

  constructor(public user: User) {
    this.email = user.email;
    this.roles = user.roles;
    this.invitedBy = user.invitedBy;
    if (user.invitedAt) {
      this.invitedAt = new Date(user.invitedAt);
    }
    if (user.acceptedAt) {
      this.acceptedAt = new Date(user.acceptedAt);
    }
    this.accepted = user.accepted;
  }
}
